import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastProvider } from './components/ToastContext';
import { Dashboard } from './pages/Dashboard';
import { EditItemPage } from './pages/EditItemPage';
import { ItemDetailPage } from './pages/ItemDetailPage';
import { NewItemPage } from './pages/NewItemPage';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30 * 1000,
			retry: 1,
			refetchOnWindowFocus: false,
		},
		mutations: {
			onError: (error) => {
				const message = error instanceof Error ? error.message : 'Erro inesperado';
				console.error('[Mutation error]', message);
			},
		},
	},
});

export function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ToastProvider>
				<BrowserRouter>
					<Routes>
						<Route path="/" element={<Dashboard />} />
						<Route path="/items/new" element={<NewItemPage />} />
						<Route path="/items/:id" element={<ItemDetailPage />} />
						<Route path="/items/:id/edit" element={<EditItemPage />} />
					</Routes>
				</BrowserRouter>
			</ToastProvider>
			<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
		</QueryClientProvider>
	);
}
